<template>
  <div class="modal">
    <div v-for="(value, key) in viewFields" :key="key" class="modal__section">
      <div class="modal__section-title">{{ value.title }}</div>

      <div
        v-for="field in value.fields"
        :key="field.label"
        class="modal__section-field"
      >
        <div class="field__label">{{ field.label }}</div>
        <div class="field__value">
          {{ bid[field.field] || 'Информация не предоставлена' }}
        </div>
      </div>
    </div>
    <div v-if="bid.comment" class="modal__section">
      <div class="modal__section-title">Комментарий по заявке:</div>
      <div class="modal__section-comment">{{ bid.comment }}</div>
    </div>
    <el-button type="success" class="modal__button" @click="$emit('close')">
      Закрыть
    </el-button>
  </div>
</template>

<script>
import { viewFields } from '@/views/PoleRF/data/poleFields'

export default {
  name: 'BidViewModal',
  props: {
    bid: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      viewFields,
    }
  },
}
</script>

<style lang="sass" scoped>
.modal
  display: flex
  flex-direction: column
  &__section
    margin-bottom: 32px
    &-title
      margin-bottom: 20px
      font-size: 16px
      font-weight: bold
      color: #1B1E24
    &-field
      display: flex
      align-items: center
      margin-bottom: 12px
      .field__label
        width: 200px
        font-size: 14px
        font-weight: bold
      .field__value
        flex: 1
        font-size: 16px
        color: #1B1E24
    &-comment
      word-break: break-word

  &__button
    width: 150px
    align-self: flex-end
</style>
